'use strict';

angular.module('app.addNewInfluencer', [])

.controller('AddNewInfluencerCtrl', function ($state, $scope, $modalInstance, $rootScope, $http, $modal, localStorageService, $location, $window, adminService, accountDetailsService, createAccountService, advertiserProjectDetailService) {
    var definitions = angular.copy($rootScope.definitions);
    $scope.countries = definitions.countries;
    $scope.languages = angular.copy(definitions.languages);
    var ls = localStorageService;
    $scope.channels = ls.get('influencerChannels');
    $scope.enableWatch = false;
    
    
    $scope.pendingCompleted = null;
    if ($scope.flag == false) {
        $scope.pendingCompleted = false;
    } 
    $scope.pendingCompletedClick = function(){
        $scope.pendingCompleted == !$scope.pendingCompleted;
    }

    $scope.searchCountries = function(event) {
        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
            for(var i = 0; i < $scope.countries.length; i++) {
                if($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                    var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                    var item = checkbox.find('label')[i];
                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                    break;
                }
            }
        }
    }

    $scope.networks = [];
    var object = {
        id: null,
        name: "No Network",
        description: null,
        contact_email: null,
        country: {
            id: null,
            code: null,
            name: null,
            isActive: null
        },
        net_id: null,
        address: null,
        phone: null, 
        ticked: false
    }
    $scope.networks.push(object);

    var newInfluencerGetInfluencerActiveUrl = $rootScope.apiUrl + 'admin/getInfluencerActive';
    $http.get(newInfluencerGetInfluencerActiveUrl, {loader: false})
        .success(function(responseNewInfluencerGetInfluencerActive){
            $scope.status = responseNewInfluencerGetInfluencerActive.data;
            $scope.status.forEach(function (val) {
                if (val.name == "New") {
                    val.ticked = true;
                    $scope.outputStatus = val;
                }
            })

            var newInfluencerGetInfluencerStatusUrl = $rootScope.apiUrl + 'admin/getInfluencerStatus';
            $http.get(newInfluencerGetInfluencerStatusUrl, {loader: false})
                .success(function(responseNewInfluencerGetInfluencerStatus){
                    $scope.approval = responseNewInfluencerGetInfluencerStatus.data;
                     $scope.approval.forEach(function (val) {
                        if (val.name == "Not Approved") {
                            val.ticked = true;
                            $scope.outputApproval = val;
                        }
                    })

                    var newInfluencerGetInfluencerGenderUrl = $rootScope.apiUrl + 'admin/getInfluencerGender';
                    $http.get(newInfluencerGetInfluencerGenderUrl, {loader: false})
                        .success(function(responseNewInfluencerGetInfluencerGender){
                            $scope.gender = responseNewInfluencerGetInfluencerGender.data;
                             $scope.gender.forEach(function (val) {
                                if (val.name == "Female") {
                                    val.ticked = true;
                                }
                            })

                            var newInfluencerNetworksUrl = $rootScope.apiUrl + 'networks';
                            $http.get(newInfluencerNetworksUrl, {loader: false})
                                .success(function(responseNewInfluencerNetworks){
                                    angular.forEach(responseNewInfluencerNetworks.data, function (item) {
                                        if (item.deletedFlag == 0) {
                                            $scope.networks.push(item);
                                        }
                                    })

                                    $scope.enableWatch = true;
                            })
                    })

            })
    })

    $scope.channels = [];
    $scope.newChannelModalHandler = function () {
        var channelModalInstance = $modal.open({       
            scope: $scope,    
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
            controller: 'NewChannelCtrl'
        });

        $scope.channelModalInstance = channelModalInstance;
        $scope.index = null;
        channelModalInstance.result.then(function(result){
            if($scope.channels){
                $scope.channels.push(result.newChannel);    
            }            
        },function(){
            //
        });
    }

    $scope.PlatformIcon = function (platform_id) {
        return adminService.getPlatformIcon(platform_id);
    }

    $scope.editChannelModalHandler = function(index){
        var channelModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
            controller: 'NewChannelCtrl' 
        })

        $scope.channelModalInstance = channelModalInstance;

        var indexNo = $scope.channels.indexOf(index);
        $scope.index = index;
        channelModalInstance.result.then(function(result){
            if (~indexNo) {
             $scope.channels.splice(indexNo, 1,result.newChannel);
            }
        })

    }

    $scope.removeChannel = function(index){
        var indexNo = $scope.channels.indexOf(index);

        if (~index) {
            $scope.channels.splice(indexNo, 1);
        }

    }

    $scope.selectGender = function(gender) {
        angular.forEach($scope.gender, function(item) {
            if(item.id == gender.id) {
                item.checked = true;
                $scope.selectedGender = gender.id;
            } else {
                item.checked = false;
            }
        })
    }

    $scope.addNewInfluencer = function () {
        $scope.selectedCountryId = "";
        $scope.countries.forEach(function (val) {
            if (val.ticked === true) {
                $scope.selectedCountryId = val.id;
            }    
        });


        $scope.selectedNetworkId = "";
        $scope.networks.forEach(function (val) {
            if (val.ticked === true)
            {
                 $scope.selectedNetworkId = val.id;
            }     
        });

        $scope.selectedLanguageId = [];
        $scope.languages.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedLanguageId.push(val.id)
        });

        $scope.selectedStatus = "";
        $scope.status.forEach(function (val) {
            if (val.ticked === true)
                $scope.selectedStatus = val.id;
        });

        var newInfluencerData = {
            domain: $scope.domain,
            name: $scope.name,
            description: $scope.description,
            isActive: $scope.selectedStatus,
            network: $scope.selectedNetworkId,
            country: $scope.selectedCountryId,
            phone: $scope.phone,
            email: $scope.email,
            languages: $scope.selectedLanguageId,
            system_email: $scope.system_email,
            pending_completed: $scope.pendingCompleted,
            gender: $scope.selectedGender
        }



        var req = {
            url: $rootScope.apiUrl + 'admin/addInfluencer',
            method: 'POST',
            data: JSON.stringify(newInfluencerData)
        }

        $http(req).success(function (responseNewInfluencer) {

            var newInfluencerId = {
                    id: responseNewInfluencer.data.id
                };

            angular.forEach($scope.channels, function(channel) {
                var dataChannel = {
                    handle: channel.handle,
                    type: channel.type,
                    platform_id: channel.platform_id,
                    blog_id: newInfluencerId.id,
                    youtubeType: channel.youtubeType
                }

                var request = {
                    url: $rootScope.apiUrl + 'channel/addChannel',
                    method: 'POST', 
                    data: JSON.stringify(dataChannel)
                }

                $http(request).success(function (responseNewInfluencerChannel) {

                })
                    .error(function (responseNewInfluencerChannel) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseNewInfluencerChannel.message;
                    });
                
            })     

            $modalInstance.close(function () {
                $log.info('Close Modal now');
            })
        })
            .error(function (responseNewInfluencer) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responseNewInfluencer.message;
            });
    }

    var getOfficialLanguage = function (countryId) {
        return advertiserProjectDetailService.getLanguageByCountry({countries: [countryId]})
            .then(function(response) {
                return response.data;
            }, function(response) {
                
            })
    };

    var buildGroupingLanguageDropdown = function (defaultLang, countryId) {
        getOfficialLanguage(countryId)
            .then( function(officialLang) {
                var officialLangList = officialLang.language;
                var languagesList = angular.copy(definitions.languages);
                var gOfficialStartNode = {
                        name: '<strong style="border-bottom: 1.5px #18bafa solid;">Official</strong>',
                        msGroup: true
                    },
                    gOtherStartNode = {
                        name: '<strong style="border-bottom: 1.5px #18bafa solid;">Others</strong>',
                        msGroup: true
                    },
                    gEndNode = {
                        msGroup: false
                    };

                var officialArr = [gOfficialStartNode];
                for (var i=0; i<languagesList.length; i++) {
                    for (var j=0; j<officialLangList.length; j++) {
                        if (officialLangList[j].id === languagesList[i].id) {
                            languagesList.splice(i, 1);
                            break;
                        }
                    }
                }

                for (var k=0; k<officialLangList.length; k++) {
                    if (defaultLang.id === officialLangList[k].id) {
                        officialLangList[k].ticked = true;
                    }
                    officialArr.push(officialLangList[k])
                }

                languagesList.unshift(gOtherStartNode);
                languagesList.push(gEndNode);
                officialArr.push(gEndNode);

                var newList = officialArr.concat(languagesList);
                $scope.languages = newList;
            });
    };

    $scope.$watch('selectedCountry', function(newValue, oldValue){
        $scope.new_language_id = "";

        if(newValue !== oldValue && newValue !== undefined && $scope.enableWatch){
            $scope.new_language_id = newValue[0].id;

            var getCountryLanguageUrl = $rootScope.apiUrl + 'admin/getCountryLanguage?country_id=' + $scope.new_language_id;
            $http.get(getCountryLanguageUrl, {loader: false})
                .success(function(responseCountryLanguage){
                    /*$scope.languages.forEach(function (defaultLang) {
                        defaultLang.ticked = false;
                        if (defaultLang.id == responseCountryLanguage.data.id) {
                            defaultLang.ticked = true;
                        }
                    })*/
                    buildGroupingLanguageDropdown(responseCountryLanguage.data, $scope.new_language_id); 
                })                                                   
        }
    }); 

})